import { render, staticRenderFns } from "./MissingClassLogs.vue?vue&type=template&id=1c27edd8&"
import script from "./MissingClassLogs.vue?vue&type=script&lang=js&"
export * from "./MissingClassLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports